<template>
  <transition name="slide-fade">
  <div class="dashboard-item dash_item">
    <div class="dashboard-content" id="ordersList">
      <div v-if="loadingOrder"></div>
      <div class="full_width" v-else-if="!loadingOrder && ordersList.length > 0">
        <div class="order" v-for="(order, index) in ordersList" v-bind:key="index" @click="changeOrder(order)">
          <button class="accordion" :class="{'active': order.order_id === activeOrderId}"> {{ order.name !== '' && order.name !== undefined && order.name !== null ? order.name : getHumanProductName(order) }}<br> <span style="color: #b2b2b2;">
              {{order.order_number}}
          </span></button>
        </div>
      </div>
      <div class="no-orers" v-else>
        {{ locale === 'en' ? 'No orders' : 'Заказы отсутствуют' }}
      </div>
    </div>
    <button class="dashboard-content__arrow dashboard-content__arrow-left" tabindex="0" type="button" @click="hideMenu()">
      <span class="dashboard-content__label dashboard-content__label-right">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 512 512" class="dashboard-content__img" focusable="false" style="transform: rotate(180deg);"><g><g>
          <g>
            <path d="M388.425 241.951L151.609 5.79c-7.759-7.733-20.321-7.72-28.067.04-7.74 7.759-7.72 20.328.04 28.067l222.72 222.105-222.728 222.104c-7.759 7.74-7.779 20.301-.04 28.061a19.8 19.8 0 0014.057 5.835 19.79 19.79 0 0014.017-5.795l236.817-236.155c3.737-3.718 5.834-8.778 5.834-14.05s-2.103-10.326-5.834-14.051z"></path>
          </g>
        </g></g> </svg>
      </span>
    </button>
  </div>
  </transition>
</template>

<script>
import appStore from '@storages/appStore'
import store from '@storages/store'
import adaptiveStore from '@storages/adaptiveStore'

export default {
  name: 'ItemDashboardSubs',
  data () {
    return {
      loadingData: true,
      reportData: []
    }
  },

  computed: {
    locale () {
      return appStore.getters.value('locale')
    },
    loadingOrder () {
      return store.getters.value('loadingOrder')
    },
    products () {
      return appStore.getters.value('products')
    },
    activeOrderId () {
      return store.getters.value('activeOrderId')
    },
    servicesList () {
      let _config = appStore.getters.value('config')
      if ('services' in _config) {
        return _config.services
      }
    },
    serviceName () {
      return appStore.getters.value('name')
    },
    ordersList () {
      return store.getters.value('ordersList')
    }
  },
  methods: {
    getHumanProductName (selectedOrder) {
      if (selectedOrder !== null) {
        let productId = selectedOrder.product_id
        if (this.products === undefined || this.products === null) {
          return ''
        }
        if (!Array.isArray(this.products)) {
          return ''
        }
        let _product = this.products.find(item => { return item !== null && item.product_id === productId })
        if (_product !== undefined) {
          return _product.product_title
        } else {
          return ''
        }
      } else {
        return ''
      }
    },
    changeOrder (order) {
      this.$eventHub.$emit('change-order', order)
      adaptiveStore.dispatch('closeOrderListUserActions')
    },
    hideMenu () {
      this.$eventHub.$emit('hide-orders-list')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/styles/varibles.scss';
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to {
  transform: translateX(-100%);
  // opacity: 0;
}
.service-name {
  margin-left: 15px;
  font-size: 18px;
  margin-bottom: 10px;
}
.full_width {
  color: white;
  font-size: 17px;
  font-weight: 800;
  width: 100%;
  padding-top: 39px;
}
a {
  color: black;
  text-decoration: none;
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}
:focus {
  outline: 0;
}
.no-orers {
  color: white;
  // font-size: 20px;
  padding-top: 50px;
  display: none;
}

.dashboard-item {
  position: absolute;
  z-index: -1;
  top: 0px;
  left: 75px;
  width: 291px;
  height: calc(100vh - 120px); // 74px - header - 45px padding-bottom
  transition: .3s;
  // height: 100%;
}
.dashboard-arrow {
  width: 0;
  height: 0;
  border-bottom: 14px solid #ffffff;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  float: right;
  margin-right: 22px;
}
.dashboard-content {
  border-top: 1px solid #353c70;
  height: 100%;
  overflow: auto;
  scrollbar-width: thin;
  // padding: 24px 6px 45px 6px;
  padding-bottom: 45px;
  border-radius: 1px;
  box-shadow: 0px 14px 38px 0 rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #2d325a;
}
.dashboard-content__arrow {
  width: 29px;
  height: 49px;
  padding: 0px;
  z-index: 1;
  min-width: 29px;
  margin-top: 13px;
  margin-right: -29px;
  border-radius: 4px;
  background-color: rgb(116, 159, 131);
  color: rgba(0, 0, 0, 0.87);
  box-shadow: none;
  font-size: 1rem;
  box-sizing: border-box;
  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  font-weight: 500;
  line-height: 1;
  text-transform: uppercase;
  border: 0;
  cursor: pointer;
  display: inline-flex;
  outline: 0;
  position: absolute;
  top: 16px;
  right: 0;
  align-items: center;
  user-select: none;
  vertical-align: middle;
  -moz-appearance: none;
  justify-content: center;
  text-decoration: none;
  -webkit-appearance: none;
  -webkit-tap-highlight-color: transparent;
}
.dashboard-content__label {
  display: inherit;
  align-items: inherit;
  font-weight: 400;
  border-bottom: 1px transparent solid;
  text-transform: none;
  justify-content: inherit;
}
.dashboard-content__img {
  display: flex;
  width: 27px;
  height: 22px;
  color: #fff;
  fill: currentColor;
}
.dashboard-content__selector {
  border-radius: 17px;
  background-color: #f4f4f4;
  display: flex;
  margin-top: 12px;
  margin-bottom: 15px;
}
.dashboard-content__selector__item {
  // padding: 11px 30px 10px 30px;
  width: 94.5px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9da6b3;
  font-size: 14px;
  cursor: pointer;
  border-radius: 17px;
}
.dashboard-content__selector__item-selected {
  color: white;
  background-color: #316fea;
}
.dashboard-content__categories {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.dashboard-content__categories__item a {
  // margin-right: 13px;
  width: 100px;
  margin-left: -3px;
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.dashboard-content__categories__item-img {
  width: 66px;
  height: 66px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #353c70;
}
.item-img_cust_width img {
  width: 13px!important;
}
.dashboard-content__categories__item-img:hover {
  background-color: #d3d3d3;
  cursor: pointer;
}
.dashboard-content__categories__item-img img {
  width: 27px;
  display: block;
  // height: 27px;
}
.dashboard-content__categories__item-text {
  text-align: center;
  // width: 62px;
  width: min-content;
  margin-top: 4px;
  color: #383838;
  font-size: 14px;
}
//custom dropdown
.accordion {
  line-height: 1.5;
  background-color: #2d325a;
  color: #fff;
  font-weight: 400;
  cursor: pointer;
  padding: 21px 18px 20px 18px;
  width: 100%;
  border: none;
  text-align: left;
  outline: none;
  font-size: 16px;
  transition: 0.4s;
  font-family: 'PT Sans', sans-serif;
}

.active, .accordion:hover {
  background-color: #353c70;
}

@media (min-width: 768px) and (max-width: 960px) {
  .dashboard-item {
    // height: calc(100% - 109px); // 74px - header - 45px padding-bottom - 10px разница в top у колонки слева и этой
    top: 0;
  }
}

@media (min-width: 426px) and (max-width: 768px) {
  .dashboard-item {
    width: 216px;
    // height: calc(100% - 109px); // 74px - header - 45px padding-bottom - 10px разница в top у колонки слева и этой
    height: calc(100vh - 114px);
    // left: 0;
  }
  .dashboard-content__arrow {
    right: 0;
  }
}

@media (min-width: 320px) and (max-width: 425px) {
  .no-orers {
    display: block;
  }
  .dashboard-item {
    width: 100vw;
    left: 0;
    // top: -15px;
    // top: -7px;
    height: calc(100vh - 68px);
  }
  .dashboard-content {
    width: 100%;
    height: 100%;
    padding-bottom: 0;
    // height: calc(100% - 100px); // 100% - padding
    // padding-bottom: 100px;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
  }
  .full_width {
    padding-top: 0;
    width: 100%;
    padding-bottom: 80px;
  }
  .accordion {
    padding: 24px 28px 19px 18px;
    font-size: 18px;
  }
  .dashboard-content__arrow {
    display: none;
    top: 2px;
    right: 70px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/headerItems/ItemDashboardSubs.vue